export enum IDTypeSeparation {
  Provvedimento = '1',
  NegoziazioneAssistita = '2',
  Accordo = '3',
  AccordoCheHaDeterminatoIlDivorzio = '4',
}
